import {
  SecretsManagerClient,
  SecretsManagerClientConfig,
} from "@aws-sdk/client-secrets-manager";

export function getClient(
  opts: SecretsManagerClientConfig,
): SecretsManagerClient {
  return new SecretsManagerClient(opts);
}
